<template>
    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="subscriptions && subscriptions.length > 0 && !loading">
        <div v-for="subscription in subscriptions" :key="subscription.id" class="card white large no-pdg"
            style="margin-bottom: 20px;max-width: 700px">
            <div class="file-ctn flx">
                <h2>Abonnement {{ subscription.propName }}</h2>
                <p>{{ subscription.address }}</p>
            </div>
            <div style="padding: 20px 50px 50px;">
                <p>
                    <strong>Statut :</strong>
                    {{ subscription.status == "trialing" ? "Période d'essai" : "En cours de validité" }}
                </p>
                <p>
                    <strong>Date de début :</strong>
                    {{ new Date(subscription.start_date * 1000).toLocaleDateString() }}
                </p>
                <p>
                    <strong>Date de fin :</strong>
                    {{ new Date(subscription.current_period_end * 1000).toLocaleDateString() }}
                </p>
                <p>
                    <span v-if="subscription.paymentMethodDetails">
                        <i :class="['fa-brands', `fa-cc-${subscription.paymentMethodDetails.card.brand}`]"
                            style="font-size: 26px"></i>
                        **** **** **** {{ subscription.paymentMethodDetails.card.last4 }}
                    </span>
                    <span v-else>
                        Aucun moyen de paiement
                    </span>
                </p>
                <div v-if="!subscription.paymentMethodDetails" class="promo"
                    style="background-color: #359590; position: absolute; right: 0px; top: 125px; z-index: 10; color: rgb(255, 255, 255); padding: 4px 10px; border-radius: 5px 0px 0px 5px; display: block;">
                    Seulement 10€ par an
                </div>
                <div class="popup-actions">
                    <template v-if="subscription.paymentMethodDetails">
                        <button class="button fill normal" @click="addPaymentMethod(subscription.id)">
                            Changer de moyen de paiement
                        </button>
                    </template>
                    <template v-else>
                        <button class="button fill orange" @click="addPaymentMethod(subscription.id)">
                            Ajouter un moyen de paiement
                        </button>
                    </template>
                    <template v-if="subscription.cancel_at_period_end">
                        <button class="button outline orange" @click="reactivate(subscription.id)">
                            Reprendre l'abonnement
                        </button>
                    </template>
                    <template v-else>
                        <button class="button outline orange" @click="openPopup(subscription.id)">
                            Résilier l'abonnement
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="!loading">
        <p>Aucun abonnement trouvé.</p>
    </div>
    <div v-else class="loader"></div>
    <AjouterPaiement :isVisible="showPaymentPopup" :subID="this.subscriptionID" @confirm="closePaymentPopup"
        @cancel1="closePaymentPopup">
    </AjouterPaiement>
    <ConfirmationPopup :isVisible="showPopup" title="Confirmer la résiliation"
        message="Êtes-vous sûr de vouloir de résilier cet abonnement ?<br/>Le CIL entier sera supprimé."
        confirmButtonText="Résilier" @confirm="cancelSubscription" @cancel="closePopup">
    </ConfirmationPopup>
</template>

<script>
import AjouterPaiement from "@/components/AjouterPaiement.vue";
import ConfirmationPopup from "@/components/ConfirmationPopup";

export default {
    components: {
        AjouterPaiement,
        ConfirmationPopup
    },
    data() {
        return {
            subscriptions: [],
            subscriptionID: "",
            subscriptionToDelete: "",
            loading: false,
            error: null,
            showPaymentPopup: false,
            showPopup: false,
        };
    },
    async mounted() {
        this.loading = true;
        this.fetchSubscription();
    },
    methods: {
        async fetchSubscription() {
            try {
                const response = await fetch(process.env.VUE_APP_API_URL + "user/subscriptions", {
                    method: 'POST',
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                });
                const result = await response.json();
                if (response.ok) {
                    this.subscriptions = result;
                } else {
                    this.error = result.error;
                }
            } catch (error) {
                this.error = error.message;
            } finally {
                this.loading = false;
            }
        },
        async addPaymentMethod(subscriptionId) {
            this.subscriptionID = subscriptionId;
            this.showPaymentPopup = true;
        },
        async cancelSubscription() {
            try {
                const response = await fetch(`${process.env.VUE_APP_API_URL}user/cancel-subscription`, {
                    method: 'POST',
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ subID: this.subscriptionToDelete })
                });
                const result = await response.json();
                if (response.ok) {
                    this.fetchSubscription();
                    this.closePopup();
                } else {
                    alert(result.error);
                }
            } catch (error) {
                console.error(error);
            }
        },
        async reactivate(subID) {
            try {
                const response = await fetch(`${process.env.VUE_APP_API_URL}user/reactivate-subscription`, {
                    method: 'POST',
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ subID })
                });
                if (response.ok) this.fetchSubscription();
            } catch (error) {
                console.error(error);
            }
        },
        openPopup(subID) {
            this.subscriptionToDelete = subID;
            this.showPopup = true;
        },
        closePopup() {
            this.subscriptionToDelete = "";
            this.showPopup = false;
        },
        closePaymentPopup() {
            this.fetchSubscription();
            this.showPaymentPopup = false;
        }
    },
};
</script>

<style>
.card p {
    margin: 10px 0;
}

.file-ctn.flx {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
}

.file-ctn.flx p {
    margin: 0;
}

.loading,
.error {
    text-align: center;
    font-size: 1.2em;
}
</style>